import { ImportDialog, type ImportField } from '@/components/import/ImportDialog';
import { buildTemplate, TEMPLATE_CONSOLIDE_FORMATEURS } from '@/lib/import-templates';
import {
  useImportPaiementsFormateurs,
  type ImportFormateurRow,
} from '@/hooks/queries/usePaiementsFormateurs';

interface Props {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  entrepriseId: string;
  activiteId: string | null;
}

const FIELDS: ImportField[] = [
  { key: 'annee', label: 'Année', required: true },
  { key: 'periode', label: 'Période' },
  { key: 'formateur', label: 'Formateur', required: true },
  { key: 'coordonnees', label: 'Coordonnées' },
  { key: 'formation', label: 'Formation' },
  { key: 'date_deroulement', label: 'Date de déroulement' },
  { key: 'montant', label: 'Montant (DA)', required: true },
  { key: 'statut', label: 'Statut', required: true },
  { key: 'date_reglement', label: 'Date de règlement' },
  { key: 'mode_paiement', label: 'Mode paiement' },
  { key: 'reference_operation', label: 'Référence opération' },
  { key: 'preuve_paiement_url', label: 'Preuve paiement' },
  { key: 'commercial', label: 'Commercial' },
  { key: 'remarques', label: 'Remarques' },
];

export function ImportConsolideFormateursDialog({
  open,
  onOpenChange,
  entrepriseId,
  activiteId,
}: Props): JSX.Element {
  const importMut = useImportPaiementsFormateurs();

  return (
    <ImportDialog<ImportFormateurRow>
      open={open}
      onOpenChange={onOpenChange}
      title="Importer le consolidé formateurs (XLSX)"
      fields={FIELDS}
      generateTemplate={() => buildTemplate(TEMPLATE_CONSOLIDE_FORMATEURS)}
      templateFilename={TEMPLATE_CONSOLIDE_FORMATEURS.filename}
      requiredHeaders={TEMPLATE_CONSOLIDE_FORMATEURS.requiredHeaders}
      onImport={async (rows) => {
        if (!entrepriseId) {
          return { success: 0, errors: ['Entreprise non sélectionnée'] };
        }
        const result = await importMut.mutateAsync({
          entrepriseId,
          activiteId,
          rows,
        });
        const summary: string[] = [];
        if (result.formateursCrees > 0)
          summary.push(`${result.formateursCrees} formateur(s) créé(s)`);
        if (result.formationsCreees > 0)
          summary.push(`${result.formationsCreees} formation(s) créée(s)`);
        if (summary.length > 0) result.errors.unshift(`ℹ ${summary.join(' · ')}`);
        return { success: result.paiementsCrees, errors: result.errors };
      }}
    />
  );
}
